import { render, staticRenderFns } from "./SSAddMerchandise.vue?vue&type=template&id=6e1ebd05&"
import script from "./SSAddMerchandise.vue?vue&type=script&lang=js&"
export * from "./SSAddMerchandise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SSAddMerchandise.vue"
export default component.exports